// blogCategory
$(document).on('ready ShoptetDOMContentLoaded', function() {
  var newSection = $(
    '<section class="category">' +
    '<div class="category-text"></div>' +
    '<div class="category-list">' +
    '<div class="detail"><a href="/blog/">Blog</a></div>' +
    '<div class="detail"><a href="/zdravy-spanek/">Zdravý spánek</a></div>' +
    '<div class="detail"><a href="/zajimavosti/">Zajímavosti</a></div>' +
    '<div class="detail"><a href="/jak-vybrat/">Jak vybrat</a></div>' +
    '<div class="detail"><a href="/rady-a-tipy/">Rady a tipy</a></div>' +
    '<div class="detail"><a href="/vse-o-luzkovinach/">Vše o lůžkovinách</a></div>' +
    '<div class="detail"><a href="/vse-o-postelovych-rostech/">Vše o postelových roštech</a></div>' +
    '<div class="detail"><a href="/vse-o-postelich/">Vše o postelích</a></div>' +
    '<div class="detail"><a href="/vse-o-matracich/">Vše o matracích</a></div>' +
    '<div class="detail"><a href="/nezarazene/">Nezařazené</a></div>' +
    '</div>' +
    '</section>'
  )

  newSection.insertAfter(
    '.in-blog h1,.in-zdravy-spanek h1,.in-zajimavosti h1,.in-jak-vybrat h1,.in-rady-a-tipy h1,.in-vse-o-luzkovinach h1,.in-vse-o-postelovych-rostech h1,.in-vse-o-postelich h1,.in-nezarazene h1,.in-vse-o-matracich h1'
  )

  if (window.innerWidth <= 768) {
    $('.category-list').on('click', function() {
      $(this).toggleClass('open')
    })
  }
})

// medailonek
// jiriDostal
$(window).on('load', function() {
  $('.in-jiri-dostal main .content-inner').wrapAll('<div class="text-wrapper"></div>')
  $('<div class="link-legend"><h2>Články</h2><div class="item"></div><div><a class="link" href="/blog/">Více článků ...</a>').appendTo('.in-jiri-dostal main .text-wrapper')
  $('.in-jiri-dostal .text-wrapper .link-legend .item').load('https://www.vyspimese.cz/cache/blog .news-item .text a.title')
  $('.type-post').show()
})

// blogBannery
jQuery(function($) {
  // jen na stránkách typu page nebo post
  if ($('body').hasClass('type-page') || $('body').hasClass('type-post')) {

    // mapování přesné textové značky → footer selektor
    var mapping = {
      '[banner-1]': '.custom-footer__banner39',
      '[banner-2]': '.custom-footer__banner40',
      '[banner-3]': '.custom-footer__banner41',
      '[banner-4]': '.custom-footer__banner42'
    }

    // projdeme všechny položky mapování
    $.each(mapping, function(markerText, selector) {
      // najdeme <div> v main s textem "[banner-X]"
      var $slot = $('#content').find('div, p').filter(function() {
        return $(this).text().trim() === markerText
      })

      if ($slot.length) {
        // skryjeme původní textový slot
        $slot.hide()

        // najdeme banner ve footeru
        var $banner = $('#footer').find(selector)

        if ($banner.length) {
          // skryjeme ho, přesuneme za slot a vykreslíme efektem
          $banner
            .hide()
            .insertAfter($slot)
            .fadeIn(600) // délku animace uprav dle potřeby
        }
      }
    })
  }
})

// blogBanners
$(function() {
  if ($('body.in-blog.type-post').length) {
    var $firstText = $('main .text').first()

    // Obalíme obsah do .page-layout
    $firstText.wrapInner('<div class="page-layout"></div>')
    var $layout = $firstText.find('.page-layout')

    // Přidáme bannery do layoutu
    var $leftBanner = $('<div class="banner left-banner"></div>').prependTo($layout)
    var $rightBanner = $('<div class="banner right-banner"></div>').appendTo($layout)

    // Přesuneme obsah bannerů z footeru
    $('#footer .custom-footer__banner43 .banner').appendTo($leftBanner)
    $('#footer .custom-footer__banner44 .banner').appendTo($rightBanner)

    // Scroll logika – 5px nad .page-layout
    $(window).on('scroll', function() {
      var scrollTop = $(window).scrollTop()
      var triggerPoint = $layout.offset().top - 5

      if (scrollTop >= triggerPoint) {
        $leftBanner.addClass('fixed-banner fixed-left')
        $rightBanner.addClass('fixed-banner fixed-right')
      } else {
        $leftBanner.removeClass('fixed-banner fixed-left')
        $rightBanner.removeClass('fixed-banner fixed-right')
      }
    })
  }
})


/**
 $(function() {
 if ($('body.in-blog.type-post').length) {
 var $firstText = $('main .text').first()

 $('<div class="banner left-banner"></div>').appendTo($firstText)
 $('<div class="banner right-banner"></div>').appendTo($firstText)

 $('#footer .custom-footer__banner43 .banner').appendTo($firstText.find('.left-banner'))
 $('#footer .custom-footer__banner44 .banner').appendTo($firstText.find('.right-banner'))
 }
 })
 **/

// blogItem
$(function() {

  $('<h2 class="blog-title">Mohlo by vás zajímat</h2><div class="blog-news-wrapper"></div>').insertAfter('.in-blog.type-post main .text:first-of-type')
  var $target = $('.in-blog.type-post .blog-news-wrapper')

  // 2) načteme prvních 3 .news-item
  $target.load(
    'https://www.vyspimese.cz/blog/ .news-wrapper .news-item:lt(3)',
    function(response, status, xhr) {
      if (status === 'error') {
        console.error('Chyba při načítání fragmentu:', xhr.status, xhr.statusText)
        return
      }

      var $me = $(this)

      // 3) opravíme obrázky (src ← data-src)
      $me.find('img').each(function() {
        var $img = $(this)
        var realSrc = $img.attr('data-src') || $img.data('src')
        if (realSrc) {
          $img.attr('src', realSrc)
        }
      })

      // 4) vytvoříme kontejner s anglickou třídou
      var $container = $('<div class="featured-news"/>')

      // 5) zpracujeme každé .news-item
      $me.find('.news-item').each(function() {
        var $item = $(this)

        // vytáhneme href z titulního odkazu
        var href = $item
          .find('.text a.title')
          .attr('href')

        // přidáme "číst článek" na konec .text
        $item
          .find('.text')
          .append(
            $('<a class="read-more" />')
              .attr('href', href)
              .text('Číst článek')
          )

        // přidáme .news-item do našeho containeru
        $container.append($item)
      })

      // 6) vyčistíme wrapper a vložíme hotový container
      $me.empty().append($container)
    }
  )
})

// blog
// adminRemoveTextBlog
function removeAuthorName() {
  if (
    $('body').hasClass('in-blog') &&
    $('body').hasClass('type-posts-listing')
  ) {
    $('#newsWrapper .news-item .text .description p').each(function() {
      const $paragraph = $(this)
      let html = $paragraph.html()

      html = html.replace(/Autor\s+článku\s+Jiří\s+Dostál\s*(<br\s*\/?>|\&nbsp;|\s)*/i, '')

      html = html.replace(/^(&nbsp;)+/, '')

      $paragraph.html(html.trimStart())
    })
  }
}

$(document).ready(function() {
  removeAuthorName()
})

document.addEventListener('ShoptetDOMContentLoaded', function() {
  removeAuthorName()
})

if($('.id-1').length){
  $(function(){
    var STORAGE_KEY = 'blogArticlesVyspimese';
    var $blogWrapper = $('.list-blog');
    if (!$blogWrapper.length) return;
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
        renderArticles(JSON.parse(stored));
        return;
    }
    $.get('/cache/blog/', function(response){
        var $html = $('<div>').html(response);
        var $items = $html.find('#newsWrapper .news-item').slice(0, 3);
        var articles = [];
        $items.each(function(){
            var $item = $(this);
            var $link = $item.find('.text a.title');
            var $img  = $item.find('.image img');
            if (!$link.length || !$img.length) return;
            var imageSrc = $img.attr('src');
            if (!imageSrc || imageSrc.indexOf('data:image') === 0) {
                imageSrc = $img.attr('data-src');
            }
            articles.push({
                title: $.trim($link.text()),
                url: $link.attr('href'),
                image: imageSrc
            });
        });
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(articles));
        renderArticles(articles);
    }).fail(function(){
        console.error('Nepodařilo se načíst blog.');
    });
    function renderArticles(articles){
        $blogWrapper.empty();
        $.each(articles, function(i, article){
            var html =
                '<div class="detail">' +
                    '<a target="_blank" href="' + article.url + '" rel="noopener noreferrer">' +
                        '<img src="' + article.image + '" loading="lazy">' +
                    '</a>' +
                    '<h2>' +
                        '<a target="_blank" href="' + article.url + '" rel="noopener noreferrer">' +
                            article.title +
                        '</a>' +
                    '</h2>' +
                    '<a target="_blank" class="more" href="' + article.url + '" rel="noopener noreferrer">' +
                        'Číst více' +
                    '</a>' +
                '</div>';
            $blogWrapper.append(html);
        });
    }
});
}